const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://api.slvassociates.org",

  AUTH: {
    LOGIN: "/auth/login",
  },

  AGENTS: {
    LIST:               "/user/list",          // GET
    CREATE:             "/users",              // POST
    UPDATE:             "/users/:id",          // PATCH - profile
    UPDATE_PASSWORD:    "/users/:id/password", // PATCH { password }
    UPDATE_STATUS:      "/users/:id/status",   // PATCH { status: "on"|"off" }
    UPDATE_LOCATION_PERM: "/users/:id/location-permission", // PATCH { allowAnyLocation: 0|1 }
  },

  USERS: {
    LIST:         "/users",
    CREATE:       "/users",
    UPDATE:       "/users/:id",
    DETAIL:       "/users/:id",
    AGENT_HOME_LOCATION: "/users/agents-home-location/:id",
    AGENTS_META:  "/users/agents-meta-data",
    CLEAR_DEVICE: "/users/:id/device/clear",
    LOGIN_WINDOW: "/users/:id/login-window",
    LOGIN_PERMISSION: "/users/:id/login-permission",
  },

  EXTERNAL_USERS: {
    LIST:   "/external-users",
    CREATE: "/external-users",
    UPDATE: "/external-users/:id",
    DETAIL: "/external-users/:id",
    DELETE: "/external-users/:id",
  },

  TRACKING: {
    ALL_LIVE:     "/gps-location/live",
    SINGLE_LIVE:  "/gps-location/live/:id/track-live",
    WEBSOCKET_URL: process.env.REACT_APP_WS_URL || "ws://143.110.252.102:1995/ws",
  },

  HISTORY: {
    GPS_HISTORY: "/gps-location/gps-history-messages",
  },

  ALERTS: {
    SEND:   "/alert/send",
    LIST:   "/alert/list",
    CANCEL: "/alert/:id/cancel",
  },

  ZONES: {
    LIST:   "/zone/list",
    CREATE: "/zone/create",
    UPDATE: "/zone/:id",
    DELETE: "/zone/:id",
  },

  REPORTS: {
    AMOUNT_COLLECTIONS: "/amount-collections/report",
    AGENT_ACTIVITY: "/amount-collections/agent-activity-report",
  },

  ATTENDANCE: {
    AGENTS_EXCEL: "/attendance/agents/excel",
  },

  APP_ALERTS: {
    LIST: "/agent-app-alerts",
  },

  GEOFENCE_ALERTS: {
    LIST: "/gps-location/geofence-alerts",
  },

  APP_USAGE: {
    LIST: "/agent-app-usage",
  },

  OFFICES: {
    LIST: "/office-locatios",
  },

  PRODUCTS: {
    LIST:   "/products",
    CREATE: "/products",
    UPDATE: "/products/:id",
    DETAIL: "/products/:id",
  },

  APP_RELEASES: {
    UPLOAD: "/app-releases/upload",
    LIST:   "/app-releases",
    LATEST: "/app-releases/latest",
  },
};

export const POLL_INTERVAL = 8000;

const POSITRON_ATTR =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

export const MAP_CONFIG = {
  CENTER: [16.1798, 81.1726],
  ZOOM: 13,
  TILE_THEMES: {
    light: {
      name: "Light",
      // Same Carto Positron look as the old light_all raster tiles, without the API-key watermark
      type: "vector",
      style: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
      attr: POSITRON_ATTR,
    },
    satellite: {
      name: "Satellite",
      type: "raster",
      url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
      attr: '&copy; <a href="https://www.openstreetmap.org/">OSM</a> &copy; <a href="https://opentopomap.org">OpenTopoMap</a>',
      maxZoom: 17,
      maxNativeZoom: 17,
    },
  },
  TILE_ATTR: POSITRON_ATTR,
};

export default API_CONFIG;
